import { Module } from 'vuex';
import reportsDashboard from '@/modules/reports/dashboard/store/reports-dashboard';
import reportsManagement from '@/modules/reports/management/store/reports-management';
import healthReports from '@/modules/reports/health-reports/store/health-reports';

const reports: Module<any, any> = {
    namespaced: true,
    modules: {
        reportsDashboard,
        reportsManagement,
        healthReports,
    },
};

export default reports;
